export enum FinalStandingsTableColumns {
  Entity = "entity",
  EntityId = "entityId",
  Person = "person",
  PersonId = "personId",
  Position = "position",
  ResultPlace = "resultPlace",
  Points = "points",
  ExternalId = "externalId",
  PlacingId = "placingId",
  PrizeMoney = "prizeMoney",
}
